var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.500977,
    width: 100,
    height: 100,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1940_3923",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1940_3923",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEmElEQVR4nO2dXYhVVRTH/xpNWVlUGBS9KD2UH5UMmM1d69wopXqxzxktpo+3XsQo+oLg9ulTEFo5+RARQ0iQ9pBkA4YUMoUgPZRJ1kMNZYUaBqXigP3jnHvvMD2U3Tnr3r33af3g/zDMB6z9O/vMPufcvQ7gOI7jOI7jOI7jOI7jOI7jOI7jOI4TLazjbAouLFLH5RQsaOVqCvqL1HBDkfbXze81f675O83fvwVnha4nKrgcc1jHFaxBmGGIGR6mYj0Vm6jYQsUOCj6lYD8FP1Fwggoa53jxtxVfUTBOwQcUvE3Ba1S8SME6Ku6ioEbF/PyAQKpwBS5ghqUU3E3BExRspmJna4B/68Lgskf5lYp9FIxRMULFY8xwJwdwLZfhfMRCfgqg4B4q3msddfyf5iAF2yhYE+y0WMwCxUQEg8HIMpHPnt6JGMQZVLwSQeGMOoINBGZ3X4jLYAdSXu+2jAeDH3maWATD3ZExgLkUHAleoCYWwWGuxLn2QprXDOEL1CSz1l6IYncEhTHJCD6xv32hmAxemCabSdMrfmZYEkFRTDoZllhfBIYvShNOhiFLIU8HL0gTj+AZSyFvBS9Ik88WSyG7IiiIieczSyHfBC1m+CpyaH7oAS0Xwc92QhTHghbTGCQnT5LvbiRvnht+cGeWP9mPc8rLuAkXBy+mMcgpDh8k199PZrNCD3DnqePK8kJqWBSVkDb795APXRd+kDtJhpXlhWTQKIXknDpFjo2Sqy5JRci95YUobotWSJvfj5KbnyRv7As/6P8WwbpqPANpnEZIm4mvycdvjVnIC+WFCB5NRkib8e3k6gXVfIJIwfPJCcmJcZks2Goh5KUkhcS5TN5RXohiY9JCYlomC3ZZCBmphJAYlsmC8fJCBG9URkj4ZfJeixkyWjkh4ZbJ+yxmyDuVFdLrZbLgWxcS13XLAT9lxXTKEnxuMUP8n7qaSdltMUN82atmM2TMQohfGKqZkG3lhfitExqeskYthPjNRTUTsslCyCM9W4VoxW+/K54tL0TxQPBCGhV5QGWxLYEZVgUvpFGZR7hrygvJN/mHLqRRkQ85CFZYCPGPAamRkAxLywtZjouimiGHfozpCWCnM2ReaSGFFMEfwYVMRviMvLMcJzDLRojiQNBihivwYWuLO73ThHwUQUFMPDvthPiGHRoIedNSiG9p09JCnrIU4ps+taQQyw5BrGNxBOdgJp0aFlkK8cYBGlHjgEKKt9ZgCSEfm8oohHjzGcbVfKaO87w9E2Yi41BX2jMVUgT3Bf/nqInF4pb7aaRsCF6kJpORrsoohACzXQr+i4yXe9IEc0pMDXdQ8X0ERyGjiuC7fKNsz0T8TcpC9FGxOt+qVTQTDj0YGrSR8taiffpC9CEW8rbbrOEaCm4vNosKXqViOwVfUPBLwkf9kaLVuOLDqFuNz2hG5W8ryHB9a//7Wiqea/UCHqXi/eICVPAlBT906cHYsdZs/udm/M3e9ek34+8G7MeZU6+bUFw67TUUi6e9nqLeSvPrvCVh++cGcJm/rsJxHMdxHMdxHMdxHMdxHMdxHMdxHCTBXxp4UPpplArJAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.a8117163ec21697df004764c1f07786c.svg";
export { ForwardRef as ReactComponent };